module.exports = __webpack_public_path__ + "static/media/EducationProject1.a8e2fefa.jpg";